module.exports = __webpack_public_path__ + "img/maurice-broaddus.67280d8e.png";